import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../Glob';
import { config } from '../../config';
import { IValuesCollection } from '../../../../../_common/platform/ts/appTheme';
import { IDisplayValue } from '../../../../../_common/platform/ts/Interfaces';
import DateField from '../../../../../_common/platform/tsx/DateField';
import { Notification } from '../../../tsx/notifications/Notification';
import { DirsTree } from '../../../tsx/DirsTree';
import { SelectedItemsDisplayComponent } from '../../../../../_common/platform/tsx/selectors/SelectedItemsDisplayComponent';
import SuggestionListField from '../../../../../_common/platform/tsx/SuggestionListField';

import {
    CONTEXT_MENU_SECTION_ID,
    CONTEXT_MENU_SECTION_NAME,
    ITEM_SELECTOR_SECTION_ID,
    ITEM_SELECTOR_SECTION_NAME,
    TREE_SECTION_ID,
    TREE_SECTION_NAME
} from '../bootstrapTheme';

export function BaseUIElementsPreview(glob: IGlob, theme: IValuesCollection) {
    const NEW_DATE = '2018-06-25T13:45:00';
    const ITEM_STYLE: React.CSSProperties = {
        marginBottom: '2rem'
    };

    const DISPLAY_VALUES: IDisplayValue[] = [
        {
            value: 'Item 1'
        },
        {
            value: 'Item 2'
        },
        {
            value: 'Item 3'
        },
        {
            value: 'Item 4'
        },
        {
            value: 'Item 5'
        },
        {
            value: 'Item 6'
        },
        {
            value: 'Item 7'
        },
        {
            value: 'Item 8'
        },
        {
            value: 'Item 9'
        }
    ];

    const SELECTED_DISPLAY_VALUES: IDisplayValue[] = [
        {
            value: 'Item 1'
        },
        {
            value: 'Item 2'
        },
        {
            value: 'Item 3'
        },
        {
            value: 'Item 5'
        },
        {
            value: 'Item 7'
        },
        {
            value: 'Item 8'
        }
    ];

    const VALID_VALUES: IDisplayValue[] = [
        {
            value: 'Item 1'
        },
        {
            value: 'Item 2'
        },
        {
            value: 'Item 3'
        },
        {
            value: 'Item 4'
        }
    ];

    return (
        <div id="baseUIElements">
            {/* <div id="preview_table">
                <label>Table</label>
            </div>
            <div>
                <table className="table table-striped table-bordered table-hover" key="table-preview">
                    <thead>
                        <tr>
                            <th>{ 'Col 1' }</th>
                            <th>{ 'Col 2' }</th>
                            <th>{ 'Col 3' }</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>{ 'row 1' }</td>
                            <td>{ 'row 1' }</td>
                            <td>{ 'row 1' }</td>
                        </tr>

                        <tr>
                            <td>{ 'row 2' }</td>
                            <td>{ 'row 2' }</td>
                            <td>{ 'row 2' }</td>
                        </tr>

                        <tr>
                            <td>{ 'row 3' }</td>
                            <td>{ 'row 3' }</td>
                            <td>{ 'row 3' }</td>
                        </tr>

                        <tr>
                            <td>{ 'row 4' }</td>
                            <td>{ 'row 4' }</td>
                            <td>{ 'row 4' }</td>
                        </tr>
                    </tbody>
                </table>
            </div> */}

            <div id="preview_link">
                <label>Link</label>
            </div>
            <div className="mb-3" style={ITEM_STYLE}>
                <a href="">Link</a>
            </div>

            <div id="preview_btn">
                <label>Buttons</label>
            </div>
            <div style={ITEM_STYLE}>
                <button className="btn btn-xs btn-default" key="button-default-preview-1">
                    {'Default'}
                </button>
                <button className="btn btn-sm btn-default" key="button-default-preview-2">
                    {'Default'}
                </button>
                <button className="btn btn-lg btn-default" key="button-default-preview-3">
                    {'Default'}
                </button>
                <br key="br-1" />
                <button className="btn btn-xs btn-success" key="button-success-preview-1">
                    {'Success'}
                </button>
                <button className="btn btn-sm btn-success" key="button-success-preview-2">
                    {'Success'}
                </button>
                <button className="btn btn-lg btn-success" key="button-success-preview-3">
                    {'Success'}
                </button>
                <br key="br-2" />
                <button className="btn btn-xs btn-info" key="button-info-preview-1">
                    {'Info'}
                </button>
                <button className="btn btn-sm btn-info" key="button-info-preview-2">
                    {'Info'}
                </button>
                <button className="btn btn-lg btn-info" key="button-info-preview-3">
                    {'Info'}
                </button>
                <br key="br-3" />
                <button className="btn btn-xs btn-danger" key="button-danger-preview-1">
                    {'Danger'}
                </button>
                <button className="btn btn-sm btn-danger" key="button-danger-preview-2">
                    {'Danger'}
                </button>
                <button className="btn btn-lg btn-danger" key="button-danger-preview-3">
                    {'Danger'}
                </button>
            </div>

            <div id={'preview_' + CONTEXT_MENU_SECTION_ID}>
                <label>{CONTEXT_MENU_SECTION_NAME}</label>
            </div>
            <div style={ITEM_STYLE}>
                <ul
                    style={{ position: 'relative', float: 'none' }}
                    className="dropdown-menu show"
                    key="dropdown-menu-preview"
                >
                    <li className="dropdown-item" style={{ position: 'relative' }}>
                        <a>{'Action'}</a>
                    </li>
                    <li className="dropdown-item" style={{ position: 'relative' }}>
                        <a>{'Another action'}</a>
                    </li>
                    <li className="dropdown-item" style={{ position: 'relative' }}>
                        <a>{'Something else here'}</a>
                    </li>
                    <li className="dropdown-divider"></li>
                    <li className="dropdown-item" style={{ position: 'relative' }}>
                        <a>{'Separated link'}</a>
                    </li>
                </ul>
            </div>

            <div id="preview_dateField">
                <label>Date Input</label>
            </div>
            <div style={ITEM_STYLE}>
                <div key="datefield-preview">
                    <DateField value={NEW_DATE} type={'datetime'} />
                </div>
            </div>

            <div id="preview_input">
                <label>Input</label>
            </div>
            <div style={ITEM_STYLE}>
                <div className="form-group" key="input-preview">
                    <label>{'Text Field Example'}</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Text Field Example"
                        value="Text Field Example"
                        onChange={() => {}}
                    />
                </div>
            </div>

            <div id={'preview_' + ITEM_SELECTOR_SECTION_ID}>
                <label>{ITEM_SELECTOR_SECTION_NAME}</label>
            </div>
            <div style={ITEM_STYLE}>
                <div className="suggestion-select">
                    <SelectedItemsDisplayComponent
                        mainComponent={true}
                        shortView={true}
                        value={SELECTED_DISPLAY_VALUES}
                        keySelect={false}
                        displayValues={DISPLAY_VALUES}
                        sortByDisplayValue={true}
                        allowNull={false}
                        allowAdding={false}
                        allowReordering={false}
                        hideSearchField={false}
                        singleSelectMode={false}
                        types={null}
                        listThreshold={100}
                        placeholder={null}
                        usePlaceholderAsTitle={false}
                        width={450}
                        readOnly={true}
                        theme={theme}
                        setFocus={false}
                        getValues={null}
                        getDisplayValue={null}
                        onChange={null}
                    />
                </div>

                <SuggestionListField
                    doNotSetFocusOnShowing={true}
                    value={SELECTED_DISPLAY_VALUES}
                    displayValues={DISPLAY_VALUES}
                    validValues={VALID_VALUES}
                    defaultSearchString={'item'}
                    allowNull={false}
                    keySelect={false}
                    hideSearchField={false}
                    singleSelectMode={false}
                    listThreshold={100}
                    readOnly={true}
                    theme={theme}
                    getValues={null}
                    getDisplayValue={null}
                    onChange={null}
                />
            </div>

            <div id="preview_navtab">
                <label>Nav Tabs and Pills</label>
            </div>
            <div style={ITEM_STYLE}>
                <div className="mb-2">
                    <ul className="nav nav-tabs" key="nav-tab-preview">
                        <li className="nav-item">
                            <a className="nav-link active">{'Home'}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link">{'Profile'}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link">{'Messages'}</a>
                        </li>
                    </ul>
                </div>

                <div>
                    <ul className="nav nav-pills" key="nav-pills-preview">
                        <li className="nav-item">
                            <a className="nav-link active">{'Home'}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link">{'Profile'}</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link">{'Messages'}</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div id="preview_popover">
                <label>Popover</label>
            </div>
            <div style={ITEM_STYLE}>
                <div className="popover right" key="popover-preview" style={{ position: 'relative' }}>
                    <div className="arrow"></div>
                    <h3 className="popover-header">{'Popover right'}</h3>
                    <div className="popover-body">
                        <div>
                            {
                                'Sed posuere consectetur est at lobortis. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.'
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div id="preview_modal">
                <label>Modal</label>
            </div>
            <div style={ITEM_STYLE}>
                <div style={{ position: 'relative' }} className="popup-dialog" key="modal-preview">
                    <div className="modal fade show" style={{ position: 'relative', display: 'block' }} role="dialog">
                        <div className="modal-dialog" style={{ position: 'relative' }}>
                            <div className="modal-content" style={{ position: 'relative' }}>
                                <div className="modal-header" style={{ position: 'relative' }}>
                                    <h4 className="modal-title" style={{ position: 'relative' }}>
                                        {'Example Modal'}
                                    </h4>
                                    <button type="button" className="close">
                                        &times;
                                    </button>
                                </div>

                                <div className="modal-body container-fluid" style={{ position: 'relative' }}>
                                    {'Some text here'}
                                </div>

                                <div className="modal-footer" style={{ position: 'relative' }}>
                                    <button type="button" className="btn btn-default">
                                        {'Cancel'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop fade show" style={{ position: 'relative' }}></div>
                </div>
            </div>

            {/* <div id="preview_listgroup">
                <label>List Group</label>
            </div>
            <div style={ ITEM_STYLE }>
                <div className="card" key="list-group-preview">
                    <div className="card-header">{ 'Panel heading' }</div>
                    <div className="card-body">
                        <div>{ '...' }</div>
                    </div>

                    <div className="list-group">
                        <a className="list-group-item disabled">{ 'Disabled Link' }</a>
                        <a className="list-group-item">{ 'Item 1' }</a>
                        <a className="list-group-item">{ 'Item 2' }</a>
                        <a className="list-group-item">{ 'Item 3' }</a>
                        <a className="list-group-item">{ 'Item 4' }</a>
                    </div>
                </div>
            </div> */}

            <div id="preview_panel">
                <label>Panel</label>
            </div>
            <div style={ITEM_STYLE}>
                <div key={'panel-default-preview'} className="card panel-default">
                    <div className="card-header">{'Panel heading'}</div>
                    <div className="card-body">
                        <div>
                            {
                                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
                            }
                        </div>
                    </div>

                    <div className="card-footer">{'Panel footer'}</div>
                </div>
            </div>

            <div id="preview_progress-bar">
                <label>Progress Bar</label>
            </div>
            <div style={ITEM_STYLE}>
                <div className="progress">
                    <div
                        className={
                            'progress-bar' +
                            (theme['progress-bar-striped'] ? ' progress-bar-striped' : '') +
                            (theme['progress-bar-animated'] ? ' progress-bar-animated' : '')
                        }
                        style={{ width: '67%' }}
                    ></div>
                </div>
            </div>

            <div id="preview_breadcrumb">
                <label>Breadcrumb</label>
            </div>
            <div style={ITEM_STYLE}>
                <ol className="breadcrumb" key="breadcrumb-preview">
                    <li className="breadcrumb-item">
                        <a>{'WS Root'}</a>
                    </li>
                    <li className="breadcrumb-item">
                        <a>{'Default'}</a>
                    </li>
                    <li className="breadcrumb-item active">{'Data'}</li>
                </ol>
            </div>

            <div id="preview_notifications">
                <label>Notifications</label>
            </div>
            <div style={ITEM_STYLE}>
                <div
                    style={{ position: 'relative' }}
                    className="platform-notifications platform-notifications-preview"
                    key="notification-preview"
                >
                    <Notification
                        key={'test-2'}
                        id={1}
                        value={{
                            id: 1,
                            type: 'success',
                            widgetRunTimeID: null,
                            options: {
                                manualDestroy: true
                            },
                            messages: [
                                {
                                    count: 1,
                                    content: 'Success Notification'
                                }
                            ]
                        }}
                        glob={glob}
                    />

                    <Notification
                        key={'test-1'}
                        id={0}
                        value={{
                            id: 1,
                            type: 'fail',
                            widgetRunTimeID: null,
                            options: {
                                manualDestroy: true
                            },
                            messages: [
                                {
                                    count: 1,
                                    content: 'Error Notification'
                                }
                            ]
                        }}
                        glob={glob}
                    />

                    <Notification
                        key={'test-3'}
                        id={2}
                        value={{
                            id: 2,
                            type: 'warning',
                            widgetRunTimeID: null,
                            options: {
                                manualDestroy: true
                            },
                            messages: [
                                {
                                    count: 1,
                                    content: 'Warning Notification'
                                }
                            ]
                        }}
                        glob={glob}
                    />
                </div>
            </div>

            <div id={'preview_' + TREE_SECTION_ID}>
                <label>{TREE_SECTION_NAME}</label>
            </div>
            <div style={ITEM_STYLE}>
                <div className="platform-tree" key="notification-tree">
                    <DirsTree
                        id={'id'}
                        rootId={config.TEMPLATES_ROOT_DIR_ID}
                        rootName={config.TEMPLATES_ROOT_DIR_NAME}
                        collapsed={false}
                        glob={glob}
                    />
                </div>
            </div>

            <div id="preview_scrollbar">
                <label>Scroll Bar</label>
            </div>
            <div style={ITEM_STYLE}>
                <div className="platform-scrollbar" key="notification-scrollbar">
                    <ul
                        style={{
                            position: 'relative',
                            float: 'none',
                            overflowY: 'scroll',
                            height: '100px'
                        }}
                        className="dropdown-menu show"
                        key="dropdown-menu-preview"
                    >
                        <li className="dropdown-item" style={{ position: 'relative' }}>
                            <a>{'Action'}</a>
                        </li>
                        <li className="dropdown-item" style={{ position: 'relative' }}>
                            <a>{'Another action'}</a>
                        </li>
                        <li className="dropdown-item" style={{ position: 'relative' }}>
                            <a>{'Something else here'}</a>
                        </li>
                        <li className="dropdown-divider"></li>
                        <li className="dropdown-item" style={{ position: 'relative' }}>
                            <a>{'Separated link'}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
